import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noEmpSearch'
})
export class NoEmpSearchPipe implements PipeTransform {

  transform(list: any, value?: any): any {
    if (!list || value === null || value === '') {
      return list;
    }
    return list.filter(item =>
      this.changeToBlank(item.statushradmin_desc).indexOf(this.changeToBlank(value)) !== -1 ||
      this.changeToBlank(item.certificateid).indexOf(this.changeToBlank(value)) !== -1 
      // ||
      // this.changeToBlank(item.statusanalytics_desc).indexOf(this.changeToBlank(value)) !== -1
    );
  }

  changeToBlank(value) {
    if (value === null) {
      return '';
    }
    return value.toLowerCase().trim();
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/no-emp-search.pipe.ts